export default __webpack_public_path__ + "static/media/LogoDark.c6d84581.svg";